const usingServiceAdvantage = {
  en: {
    title: 'High quality service starts with a high quality POS',
    desc: 'Upgrade the customer experience and your bottom-line with the all-in-one Chowbus POS',
    items: [
      {
        title: 'Upgrade the Customer Experience',
        image: `${process.env.ASSETS_PREFIX}/businesstype/using_fullservice_advantage_1.jpeg`,
        items: [
          {
            desc: 'Orders move faster and more accurately between the front and back house with the Chowbus POS system.',
          },
          {
            desc: 'From handheld tablets to self-ordering kiosks, our POS hardware and software works in harmony across your operation.',
          },
          { desc: 'Streamlined operations will turn your tables faster and generate more sales in less time!' },
        ],
      },
      {
        title: 'Better Technology for More Sales',
        image: `${process.env.ASSETS_PREFIX}/businesstype/using_fullservice_advantage_2.jpeg`,
        items: [
          {
            desc: 'Manage your dine-in, pick-up delivery, and website orders all in one place',
          },
          {
            desc: 'Service more guests in less time with QR code digital menus, handhelds, mobile ordering, online website ordering, and more.',
          },
          { desc: 'Use our loyalty, CRM, and gift card programs to turn one-time customers into your regulars!' },
        ],
      },
      {
        title: 'Boost Profits the Easy Way',
        image: `${process.env.ASSETS_PREFIX}/businesstype/using_fullservice_advantage_3.jpeg`,
        items: [
          {
            desc: 'Our POS system saves the average restaurant up to $8,000/month in labor costs',
          },
          {
            desc: 'Save your time and effort on performance reporting. We automate it for you!',
          },
          {
            desc: 'Our POS removes redundant costly tasks, which can boost sales volume, tips, staff productivity, and your bottom line!',
          },
        ],
      },
    ],
  },
  zh: {
    title: '优质的POS产品帮助您提供高质量的餐饮服务',
    desc: 'Chowbus POS一站式解决方案帮助您显著提升客户体验和餐厅经营效率',
    items: [
      {
        title: '升级顾客体验',
        image: `${process.env.ASSETS_PREFIX}/businesstype/using_fullservice_advantage_1.jpeg`,
        items: [
          {
            desc: '提升从点单到送厨的速度和准确性，减少顾客用餐等待时间',
          },
          {
            desc: '从无接触智能点餐到桌边结账，顾客可以根据自己的节奏浏览菜品、添加购物车并下单，同时享受更高效的结账体验',
          },
          {
            desc: '从智能点餐设备到厨房打印机，我们的POS硬件和软件构建了餐厅运营的生态系统',
          },
        ],
      },
      {
        title: '提高运营效率',
        image: `${process.env.ASSETS_PREFIX}/businesstype/using_fullservice_advantage_2.jpeg`,
        items: [
          {
            desc: '一站式管理您所有的订单，包括堂食、外卖、官网订单等',
          },
          {
            desc: '多渠道触达顾客，从线上点单，餐厅预约、等位，到店内无接触智能下单，Chowbus POS提供全套服务帮助您服务更多顾客',
          },
          { desc: '利用POS产品减少人工重复性操作，将有限的人力投入到更有价值的服务上' },
        ],
      },
      {
        title: '提升餐厅利润',
        image: `${process.env.ASSETS_PREFIX}/businesstype/using_fullservice_advantage_3.jpeg`,
        items: [
          {
            desc: '我们的POS产品帮助您在点单、结账、订单管理等环节显著减少人力成本',
          },
          {
            desc: '关注顾客复购率，善用会员、积分、礼品卡、营销短信等方式发展您的回头客，提升营业额',
          },
          {
            desc: '自动化呈现餐厅订单、餐品、营业额等报表数据，帮助您更好地制定策略',
          },
        ],
      },
    ],
  },
};

export default usingServiceAdvantage;
